import './PaperlessBanner.scss';

import React from 'react';

import { ReactComponent as Mail } from 'assets/icons/mail-2.svg';
import Banner from 'components/shared/Banner/Banner';
import ActionButton from 'components/shared/Buttons/ActionButton';
import { feesAndMinimumsUrl } from 'services/Externals';

const GoPaperlessBanner = ({
  selectAllPaperless,
  hasInvalidOrMissingEmail
}) => (
  <Banner className="paperless-banner">
    <span className="print-icon">
      <Mail />
    </span>
    <span className="banner-content">
      <p className="super-title">DID YOU KNOW?</p>
      <p className="title">Waive your service fee by going paperless</p>
      <p>
        Select email delivery for Statements, Confirmations, and
        Prospectuses/Shareholder Reports to waive the account service fee.
      </p>
      <p>
        <a
          className={hasInvalidOrMissingEmail ? 'disabled' : ''}
          href={feesAndMinimumsUrl}
          id="document-delivery-learn-more-link"
          rel="noopener noreferrer"
          target="_blank">
          Learn more
        </a>{' '}
        about the account service fee and other ways you can get it waived.
      </p>
      <ActionButton
        className="banner-action-button"
        id="general-section-go-paperless-button"
        onClick={selectAllPaperless}
        disabled={hasInvalidOrMissingEmail}
        type="primary">
        Waive Service Fee
      </ActionButton>
    </span>
  </Banner>
);

export default GoPaperlessBanner;
